const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path fill-rule="evenodd" d="M9.5 7.75A1.75 1.75 0 0 0 7.75 9.5v5c0 .966.784 1.75 1.75 1.75h5a1.75 1.75 0 0 0 1.75-1.75v-5a1.75 1.75 0 0 0-1.75-1.75z" clip-rule="evenodd"/><path fill-rule="evenodd" d="M12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0" clip-rule="evenodd"/></svg>';
export {
  e as w
};
